import React, { Component } from 'react';
//import moment from 'moment';
import Loading from '../../Loading';
import ItemConteudo from '../../shared/conteudo/ItemConteudo';
import ScrollListHorizontal from '../../ScrollListHorizontal';
import ModalEstudo from './ModalEstudo';

import * as TrilhaRequest from '../../../requests/trilha.request';

class ListaEstudos extends Component {

    constructor(props) {
        super(props);

        this.exists_biblioteca_conteudo = false;

        this.state = {
            loadingGeral: false,
            idConteudoAtual: undefined,
            indexConteudoAtual: -1,
            conteudos: [],
            conteudosAdicionados: []
        }
        this.onClickStudent = this.onClickStudent.bind(this);
        this.onClickConteudo = this.onClickConteudo.bind(this);
        this.closeModalConteudo = this.closeModalConteudo.bind(this);
    }

    componentDidMount() {
        // console.log('componentDidMount ',this.props.userContainer.state.isUserStudent)
        if (this.props.idPeriodoSimulado) {
            this.popularConteudos();
        }
    }

    componentDidUpdate(prevProps) {
        // Don't forget to compare props, or you’ll cause an infinite loop
        if (this.props.idPeriodoSimulado !== prevProps.idPeriodoSimulado) {
            //this.fetchData(this.props.userID);
            this.popularConteudos();
        }
    }

    onClickStudent(item, index) {

        if (this.state.coordenador) {
            this.setState({ showModalDetalhes: true, conteudoAtualIdx: index, conteudoAtualId: item.id });
        } else {
            this.setState({ showModalConfirmacao: true, conteudoAtualIdx: index, conteudoAtualId: item.id });
        }
    }

    onClickConteudo(item, index) {

        this.setState({ showModalConteudo: true, indexConteudoAtual: index, idConteudoAtual: item.id });
    }

    closeModalConteudo() {
        this.popularConteudos();
        this.setState({ showModalConteudo: false, indexConteudoAtual: -1, idConteudoAtual: undefined });
    }

    async popularConteudos() {
        //TODO: Talvez seja interessante adicionar um cache para evitar buscar os conteúdos sempre que acessar esta trilha

        //this.props.idPeriodoSimulado
        this.setState({ loadingGeral: true });

        var conteudos = await TrilhaRequest.getEstudos(this.props.idPeriodoSimulado);
        // console.log('conteudos ', conteudos)
        var mapConteudos = conteudos.map(item => ({
            id: item.idStudentStudy,
            img: this.getUrlTumbnail(item.obUrlThumbnail, 192, 144),
            titulo: item.txStudy,
            porcentagem: 0,
            tipo: item.txStudyTypeAbr,
            descricaoTipo: item.txStudyType,
            detalhes: item.txStudyDetails,
            disciplina: this.getDisciplines(item)[0].txDiscipline,
            status: item.inStatusStudy
            // dataLimite: moment(item.dtEndStudy).format("DD/MM/YYYY")
            // qtd: 5,
            // pontos: 150,
            // dia: 28,
            // diaSemana: 'SAB',
        }));

        var conteudosAdicionados = await TrilhaRequest.getEstudos(this.props.idPeriodoSimulado, true);
       // console.log('conteudosAdicionados',conteudosAdicionados);
        var mapConteudosAdicionados = conteudosAdicionados.map(item => ({
            id: item.idStudentStudy,
            img: this.getUrlTumbnail(item.obUrlThumbnail, 192, 144),
            titulo: item.txStudy,
            porcentagem: 0,
            tipo: item.txStudyTypeAbr,
            descricaoTipo: item.txStudyType,
            detalhes: item.txStudyDetails,
            disciplina: this.getDisciplines(item)[0].txDiscipline,
            status: item.inStatusStudy,
            teacherStudy: item.inTeacherStudy===1
            // dataLimite: moment(item.dtEndStudy).format("DD/MM/YYYY")
            // qtd: 5,
            // pontos: 150,
            // dia: 28,
            // diaSemana: 'SAB',
        }));

        this.setState({ loadingGeral: false, conteudos: mapConteudos, conteudosAdicionados: mapConteudosAdicionados });
    }

    getDisciplines(itemAPI) {
        //A api está retornando as disciplinas como uma string contendo um array json, por isso está sendo feita a conversão abaixo se necessário
        var disciplines = [];
        if (!Array.isArray(itemAPI.disciplines)) {
            try {
                disciplines = JSON.parse(itemAPI.disciplines);
            } catch (error) {
                console.error(error)
            }
        } else {
            disciplines = itemAPI.disciplines || [];
        }
        return disciplines;
    }
 
    getUrlTumbnail(uri, w, h) {
        return `${process.env.REACT_APP_IMAGES}/${w}x${h}/smart${uri}`;
    }

    render() {

        const listItems = this.state.conteudos.map((item, index) => <ItemConteudo isStudent={true} key={`adap-trilha-conteudo-item-${index}`} {...item} onClickStudent={() => this.onClickConteudo(item, index)} />);
        const listItemsAdicionados = this.state.conteudosAdicionados.map((item, index) => <ItemConteudo isStudent={true} key={`adap-trilha-conteudo-item-${index}`} choosed={true} {...item} onClickStudent={() => this.onClickConteudo(item, index)} />);

        return (<div>

            {this.state.loadingGeral && <Loading />}

            {!this.state.loadingGeral && this.state.conteudos.length === 0 && this.state.conteudosAdicionados.length === 0 && <div className="edb-container" style={{ maxWidth: '960px', margin: '0 auto' }}>
                <div className="edb-col"><h1>Parabéns! Você terminou seu simulado.</h1></div>
                <div className="edb-container edb-third edb-col"><img alt="Robô corrigindo simulado" src="/images/emptystates/robots.svg" width="70%" /></div>
                <div className="edb-container edb-twothird">
                    <div className="edb-row edb-margin-bottom">
                        <h3>Enquanto estamos preparando novas atividades para você, vá em <a href="#/app/biblioteca" style={{ color: '#3388BB', fontWeight: 'bold' }}>Biblioteca de Conteúdo</a> e busque alguns estudos para você "Virar o Bicho".</h3>
                    </div>
                </div>
            </div>}

            {!this.state.loadingGeral && this.state.conteudos.length > 0 && <div>
                <div className="edb-margin-bottom">
                    <span className="edb-large edb-text-bold edb-margin-small-right">Para correr atrás do prejuízo</span>
                    <div className="edb-inline edb-line-height-medium">| Estudos de competências a serem melhoradas</div>
                </div>
                <ScrollListHorizontal items={listItems} itemWidth={200} />
            </div>}

            {!this.state.loadingGeral && this.state.conteudosAdicionados.length > 0 && <div>

                <div className="edb-margin-bottom edb-margin-top">
                    <span className="edb-large edb-text-bold edb-margin-small-right">Para você virar o bicho!</span>
                    <div className="edb-inline edb-line-height-medium">| Temas escolhidos individualmente para você ficar ainda melhor</div>
                </div>
                <ScrollListHorizontal items={listItemsAdicionados} itemWidth={200} />
            </div>}

            <ModalEstudo isOpen={this.state.showModalConteudo} onCloseModal={this.closeModalConteudo} idEstudo={this.state.idConteudoAtual} />
        </div>)
    }
}

export default ListaEstudos;